<div class="ion-padding">
	<ion-row class="ion-margin-vertical">
		<ion-col>
			<h1 class="black ion-no-margin">
				{{ 'recommendation_modal.title' | translate }}
			</h1>
		</ion-col>
	</ion-row>
	<ion-row role="region" aria-label="Row content">
		<ion-col>
			<div (click)="customization()" class="button filled ion-text-center bold pointer" role="button" tabindex="0">
				<span>{{ 'recommendation_modal.customize' | translate }}</span>
			</div>
		</ion-col>
	</ion-row>
	<ion-row role="region" aria-label="Content section">
		<ion-col>
			<p class="ion-text-center ion-no-margin">
				{{ 'recommendation_modal.or' | translate }}
			</p>
		</ion-col>
	</ion-row>
	<ion-row>
		<ion-col>
			<div (click)="recommendation()" class="button filled ion-text-center bold pointer" role="button" tabindex="0">
				<span>{{ 'recommendation_modal.recommendation' | translate }}</span>
			</div>
		</ion-col>
	</ion-row>
	<ion-icon (click)="dismiss()" class="grey" name="close" size="large" role="img" aria-label="Close icon"></ion-icon>
</div>
